import { Component, OnChanges, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { INavItems, NavOptions } from './../sidebar/sidebar.component';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent {
  protected CurrentRoute!: string;
  protected CurrentPath!: string;

  constructor(private router: Router) {
    this.router.events.subscribe((ev) => {
      if (ev instanceof NavigationEnd) {
        /* Your code goes here on every router change */
        this.CurrentPath = router.url;

        NavOptions.filter((navOpts) => {
          if (!navOpts.children) {
            if (navOpts.path === router.url) this.CurrentRoute = navOpts.label;
            return navOpts.path === router.url;
          } else {
            return navOpts.children.filter((childNavOpts) => {
              if (childNavOpts.path === router.url) this.CurrentRoute = navOpts.label;
              return childNavOpts.path === router.url;
            });
          }
        });
      }
    });
  }
}
